module.exports = __webpack_public_path__ + "static/media/SR100-W2L1 Copy.0806c967.png";